//import { BankAccountsContext } from '@app/collections/fortress/BankAccountsContext'
//import { EntityContext } from '@app/collections/fortress/EntityContext'
//import { ProfileContext } from '@app/collections/fortress/ProfileContext'
import { UserInfoContext } from '@app/collections/fortress/UserInfoContext'
import { Col, Description, DescriptionItem, Row, Spacer, Text } from '@app/components'
//import { IStore } from '@app/redux'
//import { auth } from '@app/services'
//import axios from 'axios'
//import { PlaidWidget } from 'collections/plaid'
//import { isEmpty } from 'lodash'
import React, { useContext, useEffect, useState } from 'react'
//import { useSelector } from 'react-redux'

//import { BankIcon } from '~public'

//import { CustomSelect } from './custom-select'

export const ACHPullContent: React.FC<any> = ({ /*selectedMethod, setSelectedMethod,*/ userMemo }) => {
  const { fetchUserInfo } = useContext(UserInfoContext)

  useEffect(() => {
    fetchUserInfo()
  }, [])

  const [bankDetails, setBankDetails] = useState({
    accountNumber: '',
    routingNumber: '',
    recipientName: '',
    recipientAddress: '',
    bankName: '',
    memo: '',
  })
  // Function to get bank details based on the last character of userMemo
  const getBankDetails = (userMemo: string) => {
    const lastChar = userMemo.slice(-1) // Get the last character of userMemo

    if (userMemo) {
      if (/[A-M]/.test(lastChar)) {
        // Last character is a-z
        return {
          //PNC Bank Details
          accountNumber: '4698968264',
          routingNumber: '043000096',
          //Update Address
          recipientName: 'CTS Global',
          recipientAddress: '1001 S. Main St, Kalispell, Montana, 59901',
          bankName: 'PNC Bank',
          memo: userMemo,
        }
      } else if (/[0-9]/.test(lastChar)) {
        // Last character is 0-9
        return {
          //Chase Bank Details
          accountNumber: '2901988958',
          routingNumber: '111000614',
          //Update Address
          recipientName: 'CTS Global',
          recipientAddress: '1001 S. Main St, Kalispell, Montana, 59901',
          bankName: 'Chase Bank',
          memo: userMemo,
        }
      } else if (/[N-Z]/.test(lastChar)) {
        // Last character is N-Z
        return {
          //Wells Fargo Bank Details
          accountNumber: '7729151519',
          routingNumber: '121000248',
          //Update Address
          recipientName: 'CTS Global',
          recipientAddress: '1001 S. Main St, Kalispell, Montana, 59901',
          bankName: 'Wells Fargo Bank',
          memo: userMemo,
        }
      }
    } else {
      // Default or invalid character handling
      return {
        accountNumber: '',
        routingNumber: '',
        recipientName: '',
        recipientAddress: '',
        bankName: '',
        memo: '',
      }
    }
  }

  // Get the bank details based on userMemo
  useEffect(() => {
    const tmpDetails = getBankDetails(userMemo)
    //console.log(bankDetails);
    setBankDetails(tmpDetails)
  }, [userMemo])

  return (
    <>
      <Row gutter={[10, 10]}>
        <Col span={24}>
          <Text>
            To deposit to your Coast account using an ACH, login to your online banking and use the details below to
            create a recipient. Once the recipient is created you can initiate an ACH transfer.
            <Spacer />
            <Description column={1}>
              <DescriptionItem label="Routing Number">{bankDetails.routingNumber}</DescriptionItem>
              <DescriptionItem label="Account Number">{bankDetails.accountNumber}</DescriptionItem>
              <DescriptionItem label="Recipient Name">{bankDetails.recipientName}</DescriptionItem>
              <DescriptionItem label="Bank Name">{bankDetails.bankName}</DescriptionItem>
              <DescriptionItem label="Bank Address">{bankDetails.recipientAddress}</DescriptionItem>
              <DescriptionItem label="Memo/Reference (Required)">{bankDetails.memo}</DescriptionItem>
              <DescriptionItem label="Email">{'info@ctsglobal.io'}</DescriptionItem>
            </Description>
            <Spacer />
            The memo/reference is always required.
          </Text>
        </Col>
      </Row>
    </>
  )
}
